import { generateAccessPass } from '../services/serverService';
import { listenToEmhubAccessPasses } from '../services/emhubAccessService';

/**
 * Test function to verify real-time updates for access passes
 * Call this from browser console: testRealTimeUpdates()
 */
export async function testRealTimeUpdates() {
  console.log('Testing real-time updates for access passes...');
  
  // Set up a test QRID
  const testQrid = 'TEST-REALTIME-' + Date.now().toString(36);
  console.log(`Using test QRID: ${testQrid}`);
  
  // Set up a listener for this QRID
  const unsubscribe = listenToEmhubAccessPasses(testQrid, (passes) => {
    console.log(`Real-time update received: ${passes.length} access passes`);
    console.log('Access passes:', passes);
  });
  
  // Generate a test access pass
  const testData = {
    customerName: 'Real-Time Test User',
    contactNumber: '1234567890',
    validDate: new Date().toISOString().split('T')[0], // Today's date in YYYY-MM-DD
    pickupTime: '11:30',
    returnTime: '18:30',
    type: 'Collection',
    qrid: testQrid
  };
  
  console.log('Generating access pass with data:', testData);
  
  try {
    const result = await generateAccessPass(testData);
    console.log('Access pass generation result:', result);
    
    if (result.success) {
      console.log('✅ Access pass generated successfully!');
      console.log('Unique ID:', result.uniqueId);
      console.log('Wait for the real-time update to appear automatically...');
      console.log('');
      console.log('When finished testing, call cleanupRealTimeTest() to remove the listener');
    } else {
      console.log('⚠️ Access pass generation failed:', result.error);
      unsubscribe();
    }
    
    return { result, unsubscribe };
  } catch (error) {
    console.error('❌ Access pass generation test failed:', error);
    unsubscribe();
    throw error;
  }
}

/**
 * Function to clean up the real-time test listener
 * Call this from browser console when done testing
 */
export function cleanupRealTimeTest() {
  if (window.__realTimeTestUnsubscribe) {
    console.log('Cleaning up real-time test listener...');
    window.__realTimeTestUnsubscribe();
    window.__realTimeTestUnsubscribe = null;
    console.log('✅ Listener removed');
  } else {
    console.log('No active real-time test listener found');
  }
}

// Export these functions to window to make them callable from the console
declare global {
  interface Window {
    testRealTimeUpdates: () => Promise<{ result: any; unsubscribe: () => void }>;
    cleanupRealTimeTest: () => void;
    __realTimeTestUnsubscribe: (() => void) | null;
  }
}

if (typeof window !== 'undefined') {
  window.testRealTimeUpdates = async () => {
    const result = await testRealTimeUpdates();
    // Store the unsubscribe function globally
    window.__realTimeTestUnsubscribe = result.unsubscribe;
    return result;
  };
  window.cleanupRealTimeTest = cleanupRealTimeTest;
  window.__realTimeTestUnsubscribe = null;
  
  console.log('Real-time test utilities available:');
  console.log('- testRealTimeUpdates() - Test real-time updates');
  console.log('- cleanupRealTimeTest() - Clean up test listeners');
} 